export const INTERVAL_SHORT: Record<string, string> = {
	DAILY: 'daily',
	MONTHLY: 'month',
	FORTNIGHTLY: 'fortnight',
	WEEKLY: 'week',
	QUARTERLY: 'quarter',
	ANNUAL: 'year',
	FOUR_WEEKLY: 'four week',
	IRREGULAR: 'schedule'
};

export const intervalDisplay = (interval: string, units?: number | null) => `${units && units > 1 ? `${units} ` : ''}${interval}`;

export const intervalDisplayShort = (interval: string, units?: number | null) =>
	intervalDisplay((INTERVAL_SHORT[interval] ?? interval.toLowerCase()) + (units && units > 1 ? 's' : ''), units);
